module.exports = __webpack_public_path__ + "img/gfi.15cf3b72.png";